import { NavLink, useLocation } from "react-router-dom";
import { Compass, Home, Plus, Trophy, User } from "lucide-react";
import { useLogSheet } from "@/contexts/LogSheetContext";

type NavItem = {
  to: string;
  icon: typeof Home;
  label: string;
};

const items: NavItem[] = [
  { to: "/home", icon: Home, label: "Home" },
  { to: "/explore", icon: Compass, label: "Explore" },
  { to: "/leaderboard", icon: Trophy, label: "Leaderboard" },
  { to: "/profile", icon: User, label: "Profile" },
];

export function BottomNav() {
  const { pathname } = useLocation();
  const { openSheet } = useLogSheet();

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 border-t"
      style={{
        backgroundColor: "#0A2540",
        borderColor: "#0A2540",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <ul className="flex items-center justify-around px-2 h-[64px]">
        {items.slice(0, 2).map(({ to, icon: Icon, label }) => (
          <NavButton key={to} to={to} Icon={Icon} label={label} active={pathname.startsWith(to)} />
        ))}
        <li>
          <button
            type="button"
            onClick={() => openSheet()}
            aria-label="Log a meal"
            className="flex items-center justify-center w-14 h-14 -mt-6 rounded-[var(--radius-full)] bg-[var(--colour-accent)] text-[var(--colour-text-inverse)] shadow-[0_2px_12px_rgba(0,0,0,0.06)]"
          >
            <Plus size={26} strokeWidth={2.5} />
          </button>
        </li>
        {items.slice(2).map(({ to, icon: Icon, label }) => (
          <NavButton key={to} to={to} Icon={Icon} label={label} active={pathname.startsWith(to)} />
        ))}
      </ul>
    </nav>
  );
}

function NavButton({
  to,
  Icon,
  label,
  active,
}: {
  to: string;
  Icon: typeof Home;
  label: string;
  active: boolean;
}) {
  return (
    <li>
      <NavLink
        to={to}
        aria-label={label}
        className="flex items-center justify-center w-12 h-12 rounded-[var(--radius-full)]"
        style={{
          color: active ? "var(--colour-accent)" : "#FFFFFF",
        }}
      >
        <Icon size={24} strokeWidth={active ? 2.5 : 2} />
      </NavLink>
    </li>
  );
}
